import styled from 'styled-components';

export const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  & > img {
    margin-bottom: 80px;
  }
`;
